import {initialSubscriptionState, ISubscriptionState} from '@app/core/store/state/subscription.state';
import {ESubscriptionActions, SubscriptionActions} from '@app/core/store/actions/subscription.actions';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';

export const subscriptionReducers = (
	state = initialSubscriptionState,
	action: SubscriptionActions | ErrorActions,
): ISubscriptionState => {
	switch (action.type) {
		case ESubscriptionActions.GetProducts:
		case ESubscriptionActions.GetCard:
		case ESubscriptionActions.AddCard: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESubscriptionActions.GetSubscriptions: {
			return {
				...state,
				isLoading: true,
				isLoadingSubscriptionUpdates: true,
			};
		}
		case ESubscriptionActions.SubscribeToPlan:
		case ESubscriptionActions.UnsubscribeToPlan: {
			return {
				...state,
				isLoadingSubscriptionUpdates: true,
			};
		}

		// this case should only be hit when tenant is loaded
		case ESubscriptionActions.GetSubscriptionsSuccess: {
			return {
				...state,
				subscriptions: action.subscriptions,
				isLoading: false,
				isLoadingSubscriptionUpdates: false,
			};
		}
		case ESubscriptionActions.GetInvoices: {
			return {
				...state,
				isInvoicesLoading: true,
			};
		}
		// this case should only be hit when tenant is loaded
		case ESubscriptionActions.GetInvoicesSuccess: {
			return {
				...state,
				invoices: action.invoices,
				isInvoicesLoading: false,
				invoicesPagination: action.pagination,
			};
		}
		// this case should only be hit when tenant is loaded
		case ESubscriptionActions.GetProductsSuccess: {
			return {
				...state,
				products: action.products,
				isLoading: false,
			};
		}
		case ESubscriptionActions.GetCardSuccess: {
			return {
				...state,
				card: action.card,
				isLoading: false,
			};
		}
		case ESubscriptionActions.SetIsLoading: {
			const newState = {
				...state,
			};
			newState[action.loadingKey] = action.loading;

			return newState;
		}
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		default:
			return state;
	}
};
